import { gql } from '@apollo/client';
import { NEW_ORDER } from '../fragments/orders';

// CREATE_NEW_ORDER, UPDATE_ORDERS, UPDATE_ORDER_RELATIONSHIPS eliminados
// (Bloque C-Limpieza 2026-05-08): sustituidos por SAVE_GENERIC_ORDER /
// SAVE_CAMPAIGN / SAVE_ACCIDENT / SAVE_ACTION / SAVE_COMMUNICATION atómicos.

export const DELETE_ORDER_BY_ID = gql`
  mutation deleteOrderById($id: ID!) {
    deleteOrderById(id: $id) {
      ...NewOrder
    }
  }
  ${NEW_ORDER}
`;

/**
 * UPDATE_ORDER queda VIVO únicamente para `ChangeStateModal` (cambio de
 * estado de Orders desde la UI con validaciones específicas: cannotCloseEmpty,
 * unvalidatedActions, propagación a children Accident/Communication). El
 * backend sincroniza la entidad doble vía OrderStateSyncService al recibir
 * UPDATE_ORDER.
 *
 * No usar para crear ni actualizar campos Tipo B/C entidad-doble: usar
 * el SaveX correspondiente.
 */
export const UPDATE_ORDER = gql`
  mutation UpdateOrder($input: UpdateOrder!) {
    updateOrder(input: $input) {
      ...NewOrder
    }
  }
  ${NEW_ORDER}
`;

export const UPDATE_PARENT_ORDER = gql`
  mutation ConnectNewParentOrderById($input: OrderToConnect!) {
    connectNewParentOrderById(input: $input) {
      ...NewOrder
    }
  }
  ${NEW_ORDER}
`;

export const UPDATE_ORDER_COMMUNICATION_SUCCESSOR_RELATIONSHIP = gql`
  mutation UpdateOrderCommunicationSuccessorRelationships(
    $input: UpdateOrderCommunicationSuccessorRelationships!
  ) {
    updateOrderCommunicationSuccessorRelationships(input: $input) {
      ...NewOrder
    }
  }
  ${NEW_ORDER}
`;

export const TRANSFER_ACCIDENT = gql`
  mutation TransferAccident($input: AccidentToTransfer!) {
    transferAccident(input: $input) {
      ...NewOrder
    }
  }
  ${NEW_ORDER}
`;

export const TRANSFER_ACTION = gql`
  mutation TransferAction($input: ActionToTransfer!) {
    transferAction(input: $input) {
      ...NewOrder
    }
  }
  ${NEW_ORDER}
`;

/**
 * «Convertir actuación» (W4, 15-oct-2026): pasa una actuación al otro mundo
 * (básica del recorrido ↔ actuación de una OT). Gesto de oficina: se manda
 * SIEMPRE con `skipOfflineQueue` — sin red falla a la vista en vez de
 * encolarse y descartarse en silencio al reproducirlo.
 */
export const CONVERT_ACTION = gql`
  mutation ConvertAction($input: ConvertActionInput!) {
    convertAction(input: $input) {
      mode
      sourceOrderId
      copyOrderId
      copyRoid
      targetOrderId
    }
  }
`;

export const TRANSFER_COMMUNICATION = gql`
  mutation TransferCommunication($input: CommunicationToTransfer!) {
    transferCommunication(input: $input) {
      ...NewOrder
    }
  }
  ${NEW_ORDER}
`;

/**
 * T99: Close an order manually after user confirmation.
 * Called when all actions in an expedition are validated and user confirms closure.
 */
export const CLOSE_ORDER = gql`
  mutation CloseOrder($orderId: ID!, $includeActions: Boolean) {
    closeOrder(orderId: $orderId, includeActions: $includeActions) {
      ...NewOrder
    }
  }
  ${NEW_ORDER}
`;
